import './ORGANIZATION_AREA_INDICATORS_WidgetLayout.css';

import { Avatar, Box } from '@mui/material';
import { formatPercentage, fullImagePath } from '../../../../b2b-common/helpers';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';
import AreaIndicatorBasicCard from '../../../../b2b-plans/components/area-indicators/AreaIndicatorBasicCard';
import useFwImagePath from '../../../../b2b-frameworks/hooks/useFwImagePath';
import { FilterAlt } from '@mui/icons-material';

const ORGANIZATION_AREA_INDICATORS_WidgetLayout = ({ status, areaIndicatorsData, percentage, totalCount, loggedIn = true, isSearching, atPublicDashboard = false, frameworkId = 2, onlyFrameworkIndicators = false }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    const imagePath = useFwImagePath('generic', frameworkId);
    const count = areaIndicatorsData?.length;
    return (
        <Box className={`ORGANIZATION_AREA_INDICATORS_Widget-container ${status}`}
            display='flex' flexDirection='column' justifyContent='flex-start' alignItems='flex-start'
            boxSizing={'border-box'} width='100%' height={'100%'}
        >
            <Box className='ORGANIZATION_AREA_INDICATORS_Widget-metric'
                display='flex' flexDirection='column' justifyContent='center' alignItems='flex-start'
                padding={'10px 20px'} backgroundColor={'gray'}
                boxSizing={'border-box'} width='100%' //height={'80px'}
                position={'relative'}
            >
                <div className='ORGANIZATION_AREA_INDICATORS_Widget-metric-value'>
                    {formatPercentage(percentage, 0)}
                    <span className='ORGANIZATION_AREA_INDICATORS_Widget-percent-sign'>%</span>
                </div>
                <div className='ORGANIZATION_AREA_INDICATORS_Widget-metric-label'>
                    {`${count || 0} ${t('out of')} ${totalCount} ${t('indicators')}`}
                </div>
                {imagePath && (
                    <Avatar
                        variant='circular'
                        src={fullImagePath(imagePath)}
                        alt={`FwImage`}
                        sx={{
                            width: '20px',
                            height: '20px',
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                        }}
                    />
                )}
                {onlyFrameworkIndicators && (
                    <Box
                        className='ORGANIZATION_AREA_INDICATORS_Widget-filter-indicator'
                        sx={{
                            position: 'absolute',
                            top: '37px',
                            right: '14px',
                            backgroundColor: 'transparent',
                            borderRadius: '50%',
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                        }}
                    >
                        <FilterAlt
                            sx={{ color: '#011d89', width: '15px', height: '15px' }}
                        />
                    </Box>
                )}
            </Box>
            <Box className='ORGANIZATION_AREA_INDICATORS_Widget-content'
                display='flex' flexDirection='column' justifyContent='flex-start' alignItems='flex-start'
                boxSizing={'border-box'}
                padding={'5px 15px'} width={'calc(100% - 5px)'}
                marginTop={'15px'} marginBottom={'15px'}
                sx={{ overflowY: 'auto' }}
                gap={1}
            >
                {areaIndicatorsData?.map((item, index) => (
                    <>
                        <AreaIndicatorBasicCard
                            key={index}
                            areaIndicator={item}
                            atPublicDashboard={atPublicDashboard}
                            frameworkId={frameworkId}
                        />
                    </>
                ))}
            </Box>
        </Box>
    );
}

export default ORGANIZATION_AREA_INDICATORS_WidgetLayout;